$(document).ready(function() {
  school.init();
});
function callbackFunction (resp) {
    console.log(resp);
    if (resp.result === 'success') {
        $('.success-message').show();
        $('#mc_embed_signup_scroll').fadeOut();
    } else {
        $('.mc-custom-error-message').html(resp.msg).show();
    }
}


var school = {

	init: function() {

		// init controls
		school.controls();
		school.tabs.init();

		school.newsArticles.init();

		$('table').addClass("table");

		$('.user-form').ajaxChimp({
			callback: callbackFunction
		});

        $('.school-guide-form').ajaxChimp({
            // callback: callbackFunction
        });

        school.businesses();
        school.analytics();
        school.socialFeed();

        school.alerts.init();


    },
    
    alerts: {
            

        init: function() {
            if ($('.global-alert').length != 0) {
                var dismissed = true;
                var titleCookie =  $(".global-alert").attr('data-title');
                var name = (titleCookie.replace(/\s/g, '')).toLowerCase();
                $('.global-alert .alert-close').click(function() {
                    school.alerts.dismissCurrentAlert();
                })
                dismissed = Cookies.getJSON('global-alert-' + name) == 'dismissed'
                if (dismissed ){
                    $('.global-alert').addClass('shrink');
                }else{
                    $('.global-alert').removeClass('shrink');
                }
            }   
        },

        dismissCurrentAlert: function() {
            if ($('.global-alert').length != 0) {
                var titleCookie =  $(".global-alert").attr('data-title');

                var name = (titleCookie.replace(/\s/g, '')).toLowerCase();
                $('.global-alert').addClass('shrink')
                Cookies.set('global-alert-' + name, 'dismissed');
            }
        },

    },

	controls: function() {


        var current_date = new Date();
        var current_year = current_date.getFullYear();

        $('.input-group.date').datepicker({
            startDate: "01/01/" + (current_year - 15),
            autoclose: true,
            todayHighlight: true,
            format: "dd/mm/yyyy"
        });

        $('.input-group.date').datepicker('getDate');

        $('.enrol-year').attr('min', current_year);
        $('.enrol-year').attr('value', current_year);
        $('.enrol-year').attr('max', current_year+15);

        $('.enrol-year').change(function() {

          var raw_child_date = $('.input-group.date').datepicker('getDate');
          var child_date = moment(raw_child_date);

          var startDate = new Date(child_date.year(), 0, 1);
          var endDate = new Date(child_date.year() + 1, 3, 30);

          var range = moment().range(startDate, endDate);

          if (range.contains(child_date)) {
            calculate_enrol(child_date.year(), parseInt($('.enrol-year').val()), 0);
          } else {
            calculate_enrol(child_date.year(), parseInt($('.enrol-year').val()), -1);
          }

        });

        // this is the actual prep calculator
        $('.input-group.date').datepicker().on("changeDate", function(e) {

            // yep

            var raw_input = $(this).find('input').val().split('/');
            var mm = parseInt(raw_input[1]);
            var yyyy = parseInt(raw_input[2]);

            $('.child-results').show();
            $('.child-results').find('table').find('tr').remove();

            var enrol_rows = '<tr><th>Year of Entry</th><th>Year</th></tr>';

            if (mm == "1" || mm == "2" || mm == "3" || mm == "4" || mm == "5" || mm == "6") {
                yyyy += 4;
                enrol_rows += '<tr><td>'+yyyy+'</td><td>Pre Prep</td></tr>';
                yyyy += 1;
                enrol_rows += '<tr><td>'+yyyy+'</td><td>Prep</td></tr>';
                yyyy += 9;
                enrol_rows += '<tr><td>'+yyyy+'</td><td>Year 9</td></tr>';
                yyyy += 2;
                enrol_rows += '<tr><td>'+yyyy+'</td><td>Year 11</td></tr>';
            } else {
                yyyy += 5;
                enrol_rows += '<tr><td>'+yyyy+'</td><td>Pre Prep</td></tr>';
                yyyy += 1;
                enrol_rows += '<tr><td>'+yyyy+'</td><td>Prep</td></tr>';
                yyyy += 9;
                enrol_rows += '<tr><td>'+yyyy+'</td><td>Year 9</td></tr>';
                yyyy += 2;
                enrol_rows += '<tr><td>'+yyyy+'</td><td>Year 11</td></tr>';
            }

            $('.child-results').find('table').append(enrol_rows);

        });

        $('.gallery-counter').click(function(e) {
            e.preventDefault();
            $(this).parent().find(".gallery-image").first().click();
        })

		$('.modal-bg').click(function() {
            $('.modal').removeClass("modal-active");
		});

		$('.kings-enrol').click(function() {
			$('.modal-enrol').addClass("modal-active");
		});

        $('a[href=#school-guide]').click(function(e) {
            e.preventDefault();
            $('.modal-mailchimp').addClass("modal-active");
        });

        $('#school-guide-close-button').click(function(e) {
            e.preventDefault();
            $('.modal-mailchimp').removeClass("modal-active");
        });

        $('.modal-video .modal-bg').click(function() {
            // pause video on modal close
            var iframe = $(this).closest('.modal-video').find('iframe');
            iframe[0].contentWindow.postMessage('{"method": "pause"}', '*');
        });

        $('.video-post .video-thumbnail').click(function() {
            $modal = $(this).closest('.video-post').find('.modal-video');
            $modal.addClass("modal-active");
            // play video on modal open
            var iframe = $modal.find('iframe');
            iframe[0].contentWindow.postMessage('{"method": "play"}', '*');
		});

		if ($("#calendar").length > 0) {

            school.calendar.showReedy();

            $('.reedycreek-cal').click(function(e) {
                e.preventDefault();
                school.calendar.showReedy();

                $(this).addClass("active");
                $('.pimpama-cal').removeClass("active");
                $('.logan-cal').removeClass("active");

                $('.cal-subscribe').attr('href', 'webcal://eduapp.com.au/api/v4/events_feed.ics?tk=0ac48d346f632095cf8e4a1ea79e6ce1b0d065d2&limit=99999&tag_ids[]=7851');

            })

            $('.pimpama-cal').click(function(e) {
                e.preventDefault();
                school.calendar.showPimpama();

                $(this).addClass("active");
                $('.reedycreek-cal').removeClass("active");
                $('.logan-cal').removeClass("active");

                $('.cal-subscribe').attr('href', 'webcal://eduapp.com.au/api/v4/events_feed.ics?tk=0ac48d346f632095cf8e4a1ea79e6ce1b0d065d2&limit=99999&tag_ids[]=7852');
            })

            $('.logan-cal').click(function(e) {
                e.preventDefault();
                school.calendar.showLogan();

                $(this).addClass("active");
                $('.reedycreek-cal').removeClass("active");
                $('.pimpama-cal').removeClass("active");

                $('.cal-subscribe').attr('href', 'webcal://eduapp.com.au/api/v4/events_feed.ics?tk=0ac48d346f632095cf8e4a1ea79e6ce1b0d065d2&limit=99999&tag_ids[]=12232');
            })



		}
        $('.reach-events').addClass('reedy-events');
        $('.reach-filters a').click(function(e) {
            e.preventDefault();

            var campus = $(this).attr('data-toggle');

            $('.reach-filters li').removeClass("active");
            $(this).parent().addClass("active");

            $('.reach-events').removeClass("reedy-events");
            $('.reach-events').removeClass("pimpama-events");
            $('.reach-events').removeClass("logan-events");

            $('.reach-events').addClass(campus);
        })

		// reach events
		if ($(".reach-events").length > 0) {
			$.ajax({
				url: "/events-reedy?start=" + Math.floor(Date.now() / 1000),
				type: "GET",
				success: function(response) {

					$.each(response, function(index, evnt) {

						if (index > 5) {
							return false;
						}

						var clone_event = $('.reach-events-clone').find(":first").clone(true);
                        clone_event.addClass("reedy-event");
						clone_event.find(".day").text(evnt.eventDate);
						clone_event.find(".month").text(evnt.eventMonth);
						clone_event.find(".title").text(evnt.title);

						if (evnt.allDay) {
							clone_event.find(".time").text("All Day");
						} else {
							clone_event.find(".time").text(evnt.eventStartTime + " - " + evnt.eventEndTime);
						}

						$("body").append(evnt.content);

						clone_event.click(function() {
				            $('#' + evnt.id).addClass('modal-active');
						})

						$('.reach-events').append(clone_event);

					})
				}
			});

            $.ajax({
                url: "/events-pimpama?start=" + Math.floor(Date.now() / 1000),
                type: "GET",
                success: function(response) {

                    $.each(response, function(index, evnt) {

                        if (index > 5) {
                            return false;
                        }

                        var clone_event = $('.reach-events-clone').find(":first").clone(true);
                        clone_event.addClass("pimpama-event");
                        clone_event.find(".day").text(evnt.eventDate);
                        clone_event.find(".month").text(evnt.eventMonth);
                        clone_event.find(".title").text(evnt.title);

                        if (evnt.allDay) {
                            clone_event.find(".time").text("All Day");
                        } else {
                            clone_event.find(".time").text(evnt.eventStartTime + " - " + evnt.eventEndTime);
                        }

                        $("body").append(evnt.content);

                        clone_event.click(function() {
                            $('#' + evnt.id).addClass('modal-active');
                        })

                        $('.reach-events').append(clone_event);

                    })
                }
            });

            $.ajax({
                url: "/events-logan?start=" + Math.floor(Date.now() / 1000),
                type: "GET",
                success: function(response) {

                    $.each(response, function(index, evnt) {

                        if (index > 5) {
                            return false;
                        }

                        var clone_event = $('.reach-events-clone').find(":first").clone(true);
                        clone_event.addClass("logan-event");
                        clone_event.find(".day").text(evnt.eventDate);
                        clone_event.find(".month").text(evnt.eventMonth);
                        clone_event.find(".title").text(evnt.title);

                        if (evnt.allDay) {
                            clone_event.find(".time").text("All Day");
                        } else {
                            clone_event.find(".time").text(evnt.eventStartTime + " - " + evnt.eventEndTime);
                        }

                        $("body").append(evnt.content);

                        clone_event.click(function() {
                            $('#' + evnt.id).addClass('modal-active');
                        })

                        $('.reach-events').append(clone_event);

                    })
                }
            })
		}



		// reach events
		if ($(".notices").length > 0) {

			$('.btn-switch-reedy').click(function() {
				$('.notices-pimpama').hide();
				$('.notices-kings').show();
			});

			$('.btn-switch-pimpama').click(function() {
				$('.notices-kings').hide();
				$('.notices-pimpama').show();
			});

			$.ajax({
				url: "/notices",
				type: "GET",
				dataType: "json",
				success: function(notices) {
					$.each(notices, function(index, notice) {

						var clone_notice = $('.notice-clone').find(":first").clone(true);

						clone_notice.find(".notice-title").text(notice.title);
						clone_notice.find(".notice-body").html(notice.body);

						$.each(notice.attachments, function(index, attachment) {

							// console.log(attachment)


							switch(attachment.type) {
								case "file":
									var attach = $('<a>').addClass("btn btn-primary").attr("href", attachment.url).text("Open Attachment");
									$(clone_notice).find('.attachments').append(attach)
									break;
								case "link":
									var attach = $('<a>').addClass("btn btn-primary").attr("href", attachment.url).text("Open Link");
									$(clone_notice).find('.attachments').append(attach)

									break;
								default:
									// $('.attachments').hide();
							}

						});

						$('.notices-kings').append(clone_notice);

					});
				}
			});

			$.ajax({
				url: "/notices-pimpama",
				type: "GET",
				dataType: "json",
				success: function(notices) {
					$.each(notices, function(index, notice) {

						var clone_notice = $('.notice-clone').find(":first").clone(true);

						clone_notice.find(".notice-title").text(notice.title);
						clone_notice.find(".notice-body").text(notice.body);

						$.each(notice.attachments, function(index, attachment) {

							switch(attachment.type) {
								case "file":
									var attach = $('<a>').addClass("btn btn-primary").attr("href", attachment.url).text("Open Attachment");
									$(clone_notice).find('.attachments').append(attach)
									break;
								case "link":
									var attach = $('<a>').addClass("btn btn-primary").attr("href", attachment.url).text("Open Link");
									$(clone_notice).find('.attachments').append(attach)

									break;
								default:
									$(clone_notice).find('.attachments').hide();
							}

						});

						$('.notices-pimpama').append(clone_notice);

					});
				}
			})
		}



		$(".icon-down").click(function (event) {
	       $('html, body').animate({
		        scrollTop: $( $.attr(this, 'href') ).offset().top - 100
		    }, 800);
		    return false;
	    });

		$('.banners').slick({
			arrows: true,
			prevArrow: '<button type="button" class="slick-prev"><span class="icon-down"></span></button>',
			nextArrow: '<button type="button" class="slick-next"><span class="icon-down"></span></button>'
		});

		$('.alumni-block').find('.carousel').slick({
			nextArrow: '<button type="button" class="gallery-right"><i class="icon-right"></i></button>',
			prevArrow: '<button type="button" class="gallery-left"><i class="icon-left"></i></button>',
			dots:true
		})

		$('.carousel-mask').slick({
			arrows: true,
			prevArrow: '<button type="button" class="slick-prev"><span class="icon-left"></span></button>',
			nextArrow: '<button type="button" class="slick-next"><span class="icon-right"></span></button>',
			dots:true
		});

		$('.gallery.carousel').slick({
			infinite: true,
			speed: 600,
			slidesToShow: 1,
			centerMode: true,
			variableWidth: true,
			respondTo: "slider",
			nextArrow: '<button type="button" class="gallery-right"><i class="icon-right"></i></button>',
			prevArrow: '<button type="button" class="gallery-left"><i class="icon-left"></i></button>'
		});


		$('.gallery.lightbox-gallery').slick({
			slidesToShow: 3,
			infinite: true,
			speed: 600,
			swipeToSlide: true,
			centerMode: true,
			respondTo: "slider",
			nextArrow: '<button type="button" class="gallery-right"><i class="icon-right"></i></button>',
			prevArrow: '<button type="button" class="gallery-left"><i class="icon-left"></i></button>'
		});

		$('.video-overlay').click(function() {
			$(this).hide();
		});

		$('.toggle-nav').off('click').click(function() {
			$(this).toggleClass("cross");
			$(".main-nav").toggleClass("nav-open");
            $(".newsletter-sidebar").toggleClass("nav-open");
        });
        
        $('a.newsletter-article-item').click(function() {
            $(".newsletter-sidebar").removeClass("nav-open");
            $(".toggle-nav").removeClass("cross");
        })

        // this is not used anywhere - i think...
		if ($('.prep-calculator').length > 0) {

			// populate years
			var totalYears = 20;
			var currentYear = new Date().getFullYear();
			var startYear = currentYear - 10;

			for (var i = 0; i<totalYears; i++) {
				$("#prep_calc_year").append($("<option>").attr('value', startYear).text(startYear));
				startYear++;
			}

			$('.prepalc').change(function() {

				var day = parseInt($('#prep_calc_day').val());
		        var month = parseInt($('#prep_calc_month').val());
		        var year = parseInt($('#prep_calc_year').val());

		        if (!year || !month || !day) return;

		        if (month >= 7 || (month == 6 && day == 1)) {
		          $('.prep_result span').html(year+6);
		        } else {
		          $('.prep_result span').html(year+5);
		        }
		        $('.prep_result').show();

			});

		}

	},

    calendar: {

      showReedy: function() {

          // $("#calendar").show();
          // $("#calendar-pimpama").hide();

          $('#calendar *').remove();

          $("#calendar").fullCalendar({
                events: {
                    url: "/events",
                    type: "GET",
                    data: {
                        campus: 'reedycreek'
                    },
                    error: function() {

                    }
                },
                timezone: "Australia/Brisbane",
                header: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'month,agendaWeek,agendaDay'
                },
                editable: false,
                columnFormat: {
                    month: 'ddd',   // Mon
                    week: 'ddd d/M',  // Mon 31/12
                    day: 'dddd d/M'   // Monday 31/12
                },
                timeFormat: 'h(:mm)tt',
                eventClick: function(event) {

                    // add modal window
                    $('body').append(event.content);

                    setTimeout(function() {
                        $('#' + event.id).addClass('modal-active');
                    }, 100)

                    return false;

                },
                loading: function(bool) {
                    if (bool) {
                      $('#loading').fadeIn();
                    } else {
                      $('#loading').fadeOut();
                    }
                }
            });
        },
        showLogan: function() {

            // $("#calendar").show();
            // $("#calendar-pimpama").hide();

            $('#calendar *').remove();

            $("#calendar").fullCalendar({
                events: {
                    url: "/events",
                    type: "GET",
                    data: {
                        campus: 'loganVillage'
                    },
                    error: function() {

                    }
                },
                timezone: "Australia/Brisbane",
                header: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'month,agendaWeek,agendaDay'
                },
                editable: false,
                columnFormat: {
                    month: 'ddd',   // Mon
                    week: 'ddd d/M',  // Mon 31/12
                    day: 'dddd d/M'   // Monday 31/12
                },
                timeFormat: 'h(:mm)tt',
                eventClick: function(event) {

                    // add modal window
                    $('body').append(event.content);

                    setTimeout(function() {
                        $('#' + event.id).addClass('modal-active');
                    }, 100)

                    return false;

                },
                loading: function(bool) {
                    if (bool) {
                        $('#loading').fadeIn();
                    } else {
                        $('#loading').fadeOut();
                    }
                }
            });
        },

      showPimpama: function() {
            $('#calendar *').remove();
            // $("#calendar").hide();
            // $("#calendar-pimpama").show();

            $("#calendar").fullCalendar({
                events: {
                    url: "/events",
                    type: "GET",
                    data: {
                        campus: 'pimpama'
                    },
                    error: function() {

                    }
                },
                timezone: "Australia/Brisbane",
                header: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'month,agendaWeek,agendaDay'
                },
                editable: false,
                columnFormat: {
                    month: 'ddd',   // Mon
                    week: 'ddd d/M',  // Mon 31/12
                    day: 'dddd d/M'   // Monday 31/12
                },
                timeFormat: 'h(:mm)tt',
                eventClick: function(event) {

                    // add modal window
                    $('body').append(event.content);

                    setTimeout(function() {
                        $('#' + event.id).addClass('modal-active');
                    }, 100)

                    return false;

                },
                loading: function(bool) {
                    if (bool) {
                      $('#loading').fadeIn();
                    } else {
                      $('#loading').fadeOut();
                    }
                }
            });
      },

    },

	tabs: {
		init: function() {

			$(".tab-title").click(function(e) {
				e.preventDefault();
				$('.tab-title').removeClass("active");
				$(this).addClass("active");
				var tab_id = $(this).find("a").attr("href");
				$(".tab").removeClass("active");
				$(tab_id).addClass("active");

			})
		}
	},


    newsArticles: {

        currentCategory: "",
        currentIndex: 2,

        init: function() {


            $('.news-filter').find('a').click(function(e) {
                e.preventDefault();

                $(".articles").find(".frame").remove();
                $(".top-filter").find("li").removeClass("active")
                $(this).parent().addClass("active")
                school.newsArticles.currentCategory = $(this).attr('data-cateogry');
                school.newsArticles.populate();
            });

            $('.load-more-news').click(function() {
                school.newsArticles.currentIndex += 2;
                school.newsArticles.populate();
            });

            school.newsArticles.populate();

        },

        populate: function() {

            $('.loading').show();
            $(".articles").load("/newsarticles-homepage.html?current_index=" + school.newsArticles.currentIndex + "&category_id=" + school.newsArticles.currentCategory, function() {
                $('.loading').hide();
            });
        }
    },

    businesses: function () {
        if ($('#digistorm.businesses').length > 0) {

            business.init({

              container: "#digistorm.businesses",
              clone: ".businesses-clone",
              api_token: "0ac48d346f632095cf8e4a1ea79e6ce1b0d065d2"

            });
        }
    },

    analytics: function () {
        // Track clicks on external links
        $('body').on('click', 'a[href]', function (e) {
            var domain = String(window.location.host).replace(/^www\./, '');
            var openInNewWindow = $(this).attr('target') == '_blank';
            var url = $(this).attr('href');
            var lightbox = $(this).attr('data-lightbox');

            // Find the domain of the link. Works with http, https and protocol-less urls
            var matches = url.match(/^(https?:)?\/\/(www\.)?([^\/\s]+)/);
            if (matches) {
                var linkDomain = matches[3];
                // Check if google analytics is loaded and the url is external
                if (window.ga && domain != linkDomain) {
                    ga('send', 'event', 'Navigation', 'Open URL', url);
                    // Check if the window will open externally
                    if (!lightbox) {
                        if (!openInNewWindow) {
                            e.preventDefault();

                            // Push the navigation onto the queue (will be processed after event is sent)
                            ga(function () {
                                // Navigate to url
                                window.location.href = url;
                            })

                            return false;
                        }
                    }
                }
            }
        });
    },

    socialFeed: function () {

        $('[data-youtube-feed]').each(function() {
            var wrapper = this;

            // Populate Slider
            var populateYouTube = function (posts) {
                var index = 0;
                var template = $('<div>').html($('script[type="text/template"]', wrapper).text()).text();
                var block = $('.youtube-wrapper', wrapper);
                var limit = 32;

                posts.forEach(function(post, index){
                    var socialClone = $(template);

                    // Stop loop
                    if (index >= limit) {
                        return false;
                    }

                    var newClone = socialClone.clone(true);
                    newClone.find('.date').html(moment(post.timestamp, 'X').format('MMM D'));
                    newClone.find('.youtube-title').html(post.text);
                    newClone.find('.youtube-thumbnail').css('background-image', 'url(' + post.image + ')');
                    newClone.find('.tube-item').attr('href', post.link);

                    block.append(newClone);
                });
            }

            var playlist = $('.youtube-e').attr('data-youtube-feed');

            // YouTube
            $.ajax({
                url: '/api/youtube.php?playlist=' + playlist.match(/list=(.*)/)[1],
                dataType: 'json',
                success: function (youtube) {
                    var posts = [];
                    youtube.forEach(function (post){
                        var postData = {};
                        postData.link        = 'https://www.youtube.com/watch?v=' + post.id.videoId;
                        postData.image       = post.thumbnail[0];
                        postData.text        = post.mediaTitle[0];
                        postData.description = post.mediaDesc[0];
                        postData.views       = post.mediaViews[0] != null ? post.mediaViews[0] : 0;
                        postData.likes       = post.mediaCount[0] != null ? post.mediaCount[0] : 0;
                        postData.type        = 'share';
                        postData.timestamp   = moment(post.published[0]).format('X');
                        postData.channel     = 'youtube';
                        posts.push(postData);
                    });
                    populateYouTube(posts);

                    $('.youtube-wrapper').slick({
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        arrows: false,
                        prevArrow: '<button type="button" class="slick-prev"><span class="icon-left"></span></button>',
                        nextArrow: '<button type="button" class="slick-next"><span class="icon-right"></span></button>',
                        dots:true,
                        responsive: [
                            {
                              breakpoint: 1280,
                              settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3
                              }
                            },
                            {
                              breakpoint: 1024,
                              settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                              }
                            },
                            {
                              breakpoint: 600,
                              settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                              }
                            }
                        ]
                    });
                }
            });

        });
    }


}
$('ul.school-hub-sidebar li').on('click', function(event) {
    $('ul.school-hub-sidebar li.active').removeClass('active');
    $(this).addClass('active');
    var target = $( $('ul.school-hub-sidebar li.active a[href^="#"]').attr('href') );
    if( target.length ) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: target.offset().top
        }, 800);
    }
});


function calculate_enrol(child_year, start_year, offset) {

  var earliest_year = (child_year + 4) - offset;
  var classes = ["3 Pre", "Pre Prep", "Prep", "Year 1", "Year 2", "Year 3", "Year 4", "Year 5", "Year 6", "Year 7", "Year 8", "Year 9", "Year 10", "Year 11", "Year 12"];

  $('.child-results').show();
  $('.child-results').find('table').find('tr').remove();

  $('.child-results').find('.table').append($('<tr>').append('<th>Year of Entry</th><th>Year</th>'));
  for (var i=0; i<15; i++) {

    if (classes[i] == "Pre Prep" || classes[i] == "Prep" || classes[i] == "Year 9" || classes[i] == "Year 11") {
      $('.child-results').find('.table').append($('<tr>').append('<td>' + earliest_year + '</td><td>' + classes[i]  + '</td>'));
    }

    earliest_year++;
  }

}